var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.83,4.86a5,5,0,0,0-3-.86,4.15,4.15,0,0,0-2.29.6h0A3.62,3.62,0,0,0,6,7.63H8.07a2.57,2.57,0,0,1,.41-1.24A1.61,1.61,0,0,1,10,5.7a1.66,1.66,0,0,1,1.44.57,2,2,0,0,1,.39,1.21,1.8,1.8,0,0,1-.36,1.08,2.18,2.18,0,0,1-.5.51l-.59.46a3.28,3.28,0,0,0-1.05,1.16A5.94,5.94,0,0,0,9,12.39H11a3.47,3.47,0,0,1,.11-.86,1.89,1.89,0,0,1,.68-.93l.57-.45a6,6,0,0,0,1.16-1.09A2.8,2.8,0,0,0,14,7.35,2.85,2.85,0,0,0,12.83,4.86ZM9,15.88h2.16V13.8H9ZM10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.2A8.2,8.2,0,1,1,18.2,10,8.21,8.21,0,0,1,10,18.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b59e3091dcbce815c0a8c59d3235df1f.svg";
export { ForwardRef as ReactComponent };